export interface UnreadNotificationResponseData {
  data: boolean;
}

export interface UnreadNotificationResponse {
  data: UnreadNotificationResponseData;
  message: string;
}

export interface IFetchUnreadNotifications {
  data: UnreadNotificationResponseData;
  message: string;
  stateIs: "Idle" | "Pending" | "Error";
}

const initialUnreadNotificationsData: IFetchUnreadNotifications = {
  data: {
    data: false,
  },
  message: "",
  stateIs: "Idle",
};

export default initialUnreadNotificationsData;